import { render, staticRenderFns } from "./CreateFeedContainer.vue?vue&type=template&id=6f6c64ab&"
import script from "./CreateFeedContainer.vue?vue&type=script&lang=ts&"
export * from "./CreateFeedContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports